__turbopack_context__.v({
  "className": "baumans_5843010c-module__ufT3ta__className",
  "variable": "baumans_5843010c-module__ufT3ta__variable",
});
